import { getAddress, isAddress } from 'viem';
import type { Address } from '$types/address';

export const isValidAddress = (param: string | Address): param is Address => {
  return isAddress(param);
};

//Had to introduce this for svelte html tags to accept the query as a valid address type
export const validateQueryAddress = (query: string | Address): Address | undefined => {
  if (isAddress(query)) {
    return query;
  } else return undefined;
};

export const getValidAddress = (param: string): Address | undefined => {
  try {
    return getAddress(param.toLowerCase());
  } catch (_) {
    return undefined;
  }
};
